import { actions } from '..';
import * as apiWrapups from '../../api/wrapups';
import { selectMyself } from '../reducers/config';
import { shouldFetchWrapupItems, shouldFetchWrapups } from '../reducers/wrapups';
import { all } from 'async-saga';
import { takeEvery, waitForState } from '../tools/async-saga-types';

const fetchWrapups = takeEvery(actions.fetchWrapupFolder.request, async function (ctx, folderId) {
  if (!shouldFetchWrapupItems(ctx.getState(), folderId)) { return }
  const me = await waitForState(ctx, selectMyself)
  const items = await apiWrapups.getWrapups(me, folderId)
  ctx.dispatch(actions.fetchWrapupFolder.response(folderId, items))
})

const fetchWrapupsDeep = takeEvery(actions.fetchWrapupsDeep.request, async function (ctx, folderId) {
  if (!shouldFetchWrapups(ctx.getState(), folderId)) { return }
  ctx.dispatch(actions.fetchWrapupsDeep.response(await apiWrapups.getWrapupsAndExpand(folderId)))
})

export default all(
  fetchWrapups,
  fetchWrapupsDeep,
)
